import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { env } from '@/env';

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  debug: import.meta.env.DEV,
  environment: import.meta.env.MODE,
  sampleRate: import.meta.env.DEV ? 0 : 1,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      showBranding: false,
    }),
  ],

  tracesSampleRate: import.meta.env.DEV ? 0 : 1,
});
